var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 157 99",
    style: {
      enableBackground: "new 0 0 157 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#ADADAD;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#ADADAD;stroke-miterlimit:10;}\n\t.st2{fill:#F6F6F6;}\n\t.st3{fill:none;stroke:#ADADAD;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;stroke:#ADADAD;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#3F3F3F;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#AFAFAF;}\n\t.st7{fill:none;stroke:#AFAFAF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#AFAFAF;stroke:#AFAFAF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.2,79H32.6c-1.6,0-2.9-1.3-2.9-2.9V23.2c0-1.6,1.3-2.9,2.9-2.9h95.6c1.6,0,2.9,1.3,2.9,2.9v52.9 C131,77.7,129.8,79,128.2,79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.5,74.2H36.3c-1,0-1.8-0.8-1.8-1.8V26.9c0-1,0.8-1.8,1.8-1.8h88.3c1,0,1.8,0.8,1.8,1.8v45.6 C126.3,73.4,125.5,74.2,124.5,74.2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "93.4,79 93.4,90.9 67.4,90.9 67.4,79  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.6,93c0-1.8-1.5-3.2-3.2-3.2H66.5c-1.8,0-3.2,1.5-3.2,3.2v1.5h34.3V93z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.8,74.2h49.7c1,0,1.8-0.8,1.8-1.8V36.7L74.8,74.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 16.4,
    cy: 78.2,
    r: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.1,70c2.3,1.2,3.9,4.7,3.9,8.9c0,5.2-2.5,9.3-5.6,9.3s-5.6-4.2-5.6-9.3c0-4.1,1.6-7.5,3.7-8.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 16.4,
    y1: 69.8,
    x2: 16.4,
    y2: 83.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 15.6,
    y1: 68.4,
    x2: 15.8,
    y2: 69.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 18.5,
    y1: 68.6,
    x2: 18,
    y2: 69.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 10.2,
    y1: 70.2,
    x2: 11.2,
    y2: 71.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 6.3,
    y1: 77.3,
    x2: 7.9,
    y2: 77.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 9.2,
    y1: 80.4,
    x2: 10.7,
    y2: 79.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 10,
    y1: 75.3,
    x2: 10.9,
    y2: 76.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 15,
    y1: 74.1,
    x2: 16.3,
    y2: 74.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 17.8,
    y1: 72.7,
    x2: 16.5,
    y2: 73.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 14.8,
    y1: 77.6,
    x2: 16.4,
    y2: 78.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 17.9,
    y1: 78.7,
    x2: 16.5,
    y2: 79.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 23.7,
    y1: 71.1,
    x2: 22.6,
    y2: 72.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 22.7,
    y1: 75,
    x2: 21.8,
    y2: 75.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 23.6,
    y1: 80.8,
    x2: 22.1,
    y2: 80.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 26.6,
    y1: 77.3,
    x2: 24.8,
    y2: 77.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.6,75c0,0-1-1-0.4-2c0.6-1,1.8-0.4,1.8-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M25.4,82.1v6.2c0,3.5-2.8,6.3-6.3,6.3h-5.2c-3.5,0-6.3-2.8-6.3-6.3v-6.2H25.4z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 2.3,
    y1: 94.5,
    x2: 154.8,
    y2: 94.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.6,36.8H44.7c-1.2,0-2.1,0.9-2.1,2.1v18.2c0,1.2,0.9,2.1,2.1,2.1h37.5l5.7,5l2-5h17.7 c1.2,0,2.1-0.9,2.1-2.1V38.9C109.7,37.7,108.7,36.8,107.6,36.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53.1,41.6c-3.6,0-6.6,2.9-6.6,6.6c0,2.1,1,4,2.6,5.2c1.1,0.9,2.5,1.4,4,1.4c1.5,0,2.9-0.5,4-1.4 c1.6-1.2,2.6-3.1,2.6-5.2C59.7,44.6,56.7,41.6,53.1,41.6z M53.1,43.9c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2 C51.1,44.8,52,43.9,53.1,43.9z M57.1,51.4c0,0.2-0.2,0.4-0.4,0.4c-2.2,0.1-5.2,0.1-7.2,0c-0.2,0-0.4-0.2-0.4-0.4 c0-1.3,0.4-2.5,1.2-3.3c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.3-0.1,0.3,0c0.3,0.3,0.7,0.6,1.1,0.8c0.3,0.1,0.5,0.1,0.8,0.1 c0.7,0,1.4-0.3,1.9-0.9c0.1-0.1,0.2-0.1,0.3,0C56.4,48.4,57.1,49.8,57.1,51.4L57.1,51.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 64.6,
    y1: 42.7,
    x2: 102.3,
    y2: 42.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 64.6,
    y1: 45.9,
    x2: 102.3,
    y2: 45.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 64.6,
    y1: 49.4,
    x2: 102.3,
    y2: 49.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 64.6,
    y1: 52.8,
    x2: 92,
    y2: 52.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.6,4.2h62.9c1.2,0,2.1,0.9,2.1,2.1v18.2c0,1.2-0.9,2.1-2.1,2.1H104l-5.7,5l-2-5H78.6 c-1.2,0-2.1-0.9-2.1-2.1V6.3C76.5,5.2,77.5,4.2,78.6,4.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M126.5,15.6c0,2.1,1,4,2.6,5.2c1.1,0.9,2.5,1.4,4,1.4c1.5,0,2.9-0.5,4-1.4c1.6-1.2,2.6-3.1,2.6-5.2 c0-3.6-2.9-6.6-6.6-6.6C129.5,9,126.5,12,126.5,15.6z M135.1,13.4c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-1.1,0.9-2,2-2 S135.1,12.3,135.1,13.4z M129.1,18.8c0-1.6,0.7-3,1.7-3.9c0.1-0.1,0.3-0.1,0.3,0c0.5,0.6,1.2,0.9,1.9,0.9c0.3,0,0.5,0,0.8-0.1 c0.5-0.2,0.8-0.4,1.1-0.8c0.1-0.1,0.2-0.1,0.3,0c0.2,0.2,0.4,0.3,0.6,0.6c0.7,0.8,1.2,2,1.2,3.3c0,0.2-0.2,0.4-0.4,0.4 c-2,0.1-5.1,0.1-7.2,0C129.3,19.3,129.1,19.1,129.1,18.8L129.1,18.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 83.9,
    y1: 10.1,
    x2: 121.6,
    y2: 10.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 83.9,
    y1: 13.4,
    x2: 121.6,
    y2: 13.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 83.9,
    y1: 16.9,
    x2: 121.6,
    y2: 16.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 83.9,
    y1: 20.2,
    x2: 111.3,
    y2: 20.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.c4cd41caa421428578a1681e4796df86.svg";
export { ForwardRef as ReactComponent };